// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__wp193","costSection":"styles_costSection__ulqy8","totalSummary":"styles_totalSummary__Souh6"};